import React, { useState } from "react"

export type ErrorContextType = {
  error: TransactionError | null
  setError: React.Dispatch<React.SetStateAction<TransactionError | null>>
}

export type TransactionError = {
  title: string
  text: string
  hash?: string
}

export const ErrorContext = React.createContext<ErrorContextType | null>(null)
export const ErrorProvider = ({ children }: { children: React.ReactNode }) => {
  const [error, setError] = useState<TransactionError | null>(null)

  return (
    <ErrorContext.Provider
      value={{
        error,
        setError,
      }}
    >
      {children}
    </ErrorContext.Provider>
  )
}
